
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/apparel/bottoms",
      function () {
        return require("private-next-pages/apparel/bottoms/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/apparel/bottoms"])
      });
    }
  